import React from 'react';
import { componentService } from 'js/services/component.service';

export const WalletLinking = React.lazy(() => import(/* webpackChunkName: "wallet-linking" */ './WalletLinking'));

componentService.registerPageComponents({ 'wallet-linking': WalletLinking });
